import { SwapState, swapStateReducer } from '@/domain/swap';
import {
  DEFAULT_SWAP_STATE,
  getInitialState,
} from '@/domain/swap/swapStateReducer';
import { useReducer } from 'react';

const useSwapState = (initialState: Partial<SwapState>) => {
  return useReducer(swapStateReducer(initialState), DEFAULT_SWAP_STATE, () =>
    getInitialState(initialState)
  );
};

export default useSwapState;
